module.exports = __webpack_public_path__ + "static/media/details_open.f6cbe97f.png";